// extracted by mini-css-extract-plugin
export var component = "WastePickupSearchResultsItem-module--component--A9R5U";
export var downloadButton = "WastePickupSearchResultsItem-module--downloadButton--WQ5IE";
export var downloadButtonText = "WastePickupSearchResultsItem-module--downloadButtonText--DIM4h";
export var loading = "WastePickupSearchResultsItem-module--loading--8dyY5";